<template>
    <v-app style="" >
        <div id="builder">




        <slot/>


        </div>
    </v-app>
</template>

<script>



    export default {
        name: "TestLayout",
        components:{

        },
        mounted(){

        }
    }
</script>



<style scoped >
    @import url('https://fonts.googleapis.com/css?family=PT+Sans&display=swap');
    #builder {

        font-family: 'tfutura',Arial;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
    }




</style>